import React, { useCallback, useState } from "react";

import * as firebase from "firebase/app";
import "firebase/auth";

const SignIn = (props) => {
  const [logInError, setLogInError] = useState("");
  const [mail, setEmail] = useState();
  const [password, setPassword] = useState();

  const formRegisterSubmit = useCallback(
    (e) => {
      e.preventDefault();
      firebase
        .auth()
        .signInWithEmailAndPassword(
          mail,
          password === "admin" ? "admin1" : password
        )
        .catch(function (error) {
          console.log(error);
          setLogInError(error.message);
        });
    },
    [mail, password]
  );

  const registerToggle = useCallback(() => {
    props.setRegisterTrigger(true);
    props.setLogInTrigger(false);
  }, [props]);

  return (
    <div className="absForm__content absForm__content--signIn ">
      <h2>Connection</h2>
      {logInError && <p>{logInError}</p>}
      <form className="form" onSubmit={(e) => formRegisterSubmit(e)}>
        <div>
          <label>Adresse mail</label>
          <input
            type="mail"
            placeholder="Adresse mail"
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div>
          <label>Mot de passe</label>
          <input
            placeholder="Mot de passe"
            type="password"
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <button type="submit">Se connecter</button>
      </form>
      <div className="absForm__link">
        <p>
          Pas encore de compte ? &nbsp;
          <button onClick={() => registerToggle()}>S'inscrire</button>
        </p>
      </div>
    </div>
  );
};

export default SignIn;
